<div class="grid">
	<div class="col-12">
		<div class="recuadro-widget" style="width: 100%">
			<span class="recuadro-widget-icon widget-anulacion-pagare-icon">
				<img src="../../../assets/icons/ico-consulta-poliza-lupa-documento-seguro.svg" alt="anulacion-pagare"/>
			</span>
			<div class="recuadro-widget-content widget-anulacion-pagare-content">
				<span class="widget-anulacion-pagare-title">{{ 'WIDGETS.LBL_SOLICITUDES' | translate | uppercase }}</span>
				<div class="container-number">
					<span class="recuadro-widget-number widget-anulacion-pagare-number">{{ contador }}</span>
				</div>
				<span class="recuadro-widget-text">{{ 'WIDGETS.LBL_PENDIENTESPAGARE' | translate  }}</span>

				<div class="widget-anulacion-pagare-actions">
					<button class="p-button p-widget p-state-default p-corner-all p-button-text-only btn-ver-mas"
						   type="button" *ngIf="!loading"
               (click)="visualizarSolicitudesPagare()"
					>{{ 'WIDGETS.LBL_VERMAS' | translate }}</button>
					<button
						class="p-button p-widget p-state-default p-corner-all p-button-text-only btn-actualizar"
						type="button"
            (click)="cargarContador()"
            *ngIf="!loading"
					>{{ 'WIDGETS.LBL_ACTUALIZAR' | translate }}</button>
					<div class="col-12 text-center" *ngIf="loading">
						<i class="fa fa-refresh fa-spin"></i>  <span><strong>{{'LBL_PROCESANDO' | translate }}</strong></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<p-dialog header="{{'WIDGETS.LBL_SOLICITUDESFINALIZADAS' | translate | uppercase}}" [(visible)]="showModalSolicitudes"
          *ngIf="showModalSolicitudes" [draggable]="false" [resizable]="false"
          [positionTop]="60" [contentStyle]="{'width':'1200px', 'overflow-y': 'auto'}" [responsive]="true" [modal]="true">

  <div class="grid" style="align-items: center; margin-bottom: 10px;">
    <div class="col-8" style="display: flex; gap: 10px;">
      <button class="btn-anular-todos" type="button" (click)="anularTodosPagare()" *ngIf="listSolicitudes.length>0"
              pButton icon="pi pi-times-circle" label="{{'WIDGETS.LBL_ANULARTODOS' | translate }}"></button>
      <button class="btn-actualizar-listado" type="button" (click)="actualizarListado()" *ngIf="listSolicitudes.length>0"
              pButton icon="pi pi-refresh" label="{{'WIDGETS.LBL_ACTUALIZARLISTADO' | translate }}"></button>
    </div>
    <div class="col-4" style="display: flex; gap: 8px; align-items: center;">
      <span class="p-input-icon-left" style="flex: 1;">
        <i class="pi pi-search"></i>
        <input type="text" pInputText [(ngModel)]="filtroBusqueda"
               placeholder="Buscar" style="width: 100%;"
               (keyup.enter)="buscarSolicitudes()"
               (ngModelChange)="onFiltroCambiado($event)" />
      </span>
      <button pButton type="button" label="Buscar" icon="pi pi-search"
              (click)="buscarSolicitudes()" class="btn-buscar-solicitudes"></button>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 container-integraciones">
      <p-treeTable [value]="listSolicitudes" [columns]="columnas" [paginator]="true" [rows]="rowsPerPage"
           [totalRecords]="totalRegistros" [first]="primeraFila" [lazy]="true"
           (onLazyLoad)="onLazyLoadSolicitudes($event)" [loading]="cargandoTabla" paginatorPosition="bottom">
        <ng-template pTemplate="header">
          <tr class="th-treeTable">
            <th *ngFor="let col of columnas" [ttSortableColumn]="col.field" [ttSortableColumnDisabled]="!col.sort" class="text-center">
              {{ col.header | translate }}
              <p-treeTableSortIcon [field]="col.field" *ngIf="col.sort"></p-treeTableSortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
          <tr [ttSelectableRow]="rowNode">
            <td *ngFor="let col of columnas" class="text-center">
              <p-treeTableToggler [rowNode]="rowNode" *ngIf="col.field === 'fechaSolicitud'"></p-treeTableToggler>
              <ng-container [ngSwitch]="col.field">
                <span *ngSwitchCase="'fechaSolicitud'">{{rowData.fechaSolicitud | date:'dd/MM/yyyy'}}</span>
                <span *ngSwitchCase="'idSolicitudInterno'">{{rowData.idSolicitudInterno}}</span>
                <span *ngSwitchCase="'codigoTipoDocumento'">{{rowData.codigoTipoDocumento}}</span>
                <span *ngSwitchCase="'numeroDocumento'">{{rowData.numeroDocumento}}</span>
                <span *ngSwitchCase="'nombreCompleto'">{{formatearNombre(rowData.nombreCompleto)}}</span>
                <span *ngSwitchCase="'tipoVinculacion'">{{rowData.tipoVinculacion}}</span>
                <span *ngSwitchCase="'estado'">{{rowData.estado}}</span>
                <ng-container *ngSwitchCase="'acciones'">
                  <div class="btn-group" role="group">
                    <button type="button" class="btn-accion-relanzar" *ngIf="rowData.indicadorPendienteAnularPagare"
                            (click)="anularPagare(rowData)" title="{{'WIDGETMODAL.BTN_RELANZAR' | translate}}">
                      <img class="btn-accion-relanzar-icon" src="../../../assets/icons/ico-actualizar-circulo-flechas.svg" alt="actualizar" />
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  </div>

  <div class="col-12 text-center" style="margin-top: 20px;">
    <button label="Cerrar" pButton class="btn-cerrar-modal"
            (click)="showModalSolicitudes=false"></button>
  </div>
</p-dialog>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [closeOnEscape]="false" [positionTop]="60"
          [(visible)]="modalVerificacion.verificando" *ngIf="modalVerificacion.verificando"
          [contentStyle]="{'width':'600px'}"
          header="{{ (modalVerificacion.individual ? 'WIDGETMODAL.LBL_TITULOMODALVERIFICADOINDIVIDUAL' : 'WIDGETMODAL.LBL_TITULOMODALVERIFICADO') | translate }}"
          [modal]="true">
  <!-- Vista para mostrar la verificacion del archivo -->
  <div *ngIf="modalVerificacion.estActual === 'INIT'" class="col-12 text-center">
    <div class="col-12 text-center">
      <img src="assets/images/preaprobados/loading.gif" alt=""/>
    </div>
    <div class="col-12 text-center">
      <span>{{ (modalVerificacion.individual ? 'WIDGETMODAL.LBL_VERIFICACIONINDIVIDUAL' : 'WIDGETMODAL.LBL_VERIFICACIONENCURSO') | translate }}</span>
    </div>
    <div class="col-12 text-center" *ngIf="!modalVerificacion.individual">
      <span style="color: #009638">{{excelAvance.avance ? utilitiesService.obtenerPlazoCorrecto(excelAvance.avance* 100) : 0}}% </span>
    </div>
  </div>
  <!-- Vista para mostrar errores -->
  <div *ngIf="modalVerificacion.estActual === 'FINVER' && modalVerificacion.error" class="col-12">
    <div class="col-12 text-center">
      <i class="fa fa-times-circle-o" style="color:red; font-size: 30px"></i>
    </div>
    <div class="col-12 text-center">
      <span>({{excelAvance.errores.length}}) {{ 'MODALCARGAARCHIVO.LBL_ERRORESENCONTRADOS' | translate }}</span>
    </div>
    <div class="col-12" style="max-height: 150px; overflow:auto;">
      <ol>
        <li *ngFor="let error of excelAvance.errores">
          <span class="badge">{{error}}</span>
        </li>
      </ol>
    </div>
  </div>
  <!-- Vista para mostrar el archivo verificado correctamente -->
  <div *ngIf="modalVerificacion.estActual === 'FINVER' && !modalVerificacion.error" class="col-12 text-center">
    <div class="col-12">
      <strong>{{ 'MODALCARGAARCHIVO.LBL_EXITO' | translate }}</strong>
    </div>
    <div class="col-12">
      <img class="img-comprobados" src="assets/images/preaprobados/icons8-comprobado.gif" alt=""/>
    </div>
    <div class="col-12">
      <span>{{ 'WIDGETMODAL.LBL_VERIFICACIONCOMPLETADA' | translate }}</span>
    </div>
  </div>
  <div class="col-12 form-footer-buttons">
    <div class="form-group col-12">
      <button *ngIf="modalVerificacion.estActual !== 'INIT'" label="{{ 'MODALCARGAARCHIVO.BTN_CERRAR' | translate }}" pButton
              class="p-button-secondary btns-acciones" (click)="cerrarVerificacion(modalVerificacion.individual)"></button>
    </div>
  </div>
</p-dialog>

<p-confirmDialog #cd key="anulacion-pagare-widget" appendTo="body">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
